import { render, staticRenderFns } from "./BoCustomerEmailDatatable.vue?vue&type=template&id=730e432a&scoped=true"
import script from "./BoCustomerEmailDatatable.vue?vue&type=script&lang=js"
export * from "./BoCustomerEmailDatatable.vue?vue&type=script&lang=js"
import style0 from "./BoCustomerEmailDatatable.vue?vue&type=style&index=0&id=730e432a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730e432a",
  null
  
)

export default component.exports